import { TableCell, TableRow } from '@mui/material';
import React from 'react';
import Swal from 'sweetalert2';
import firebase from '../firebase';
/* eslint-disable */
function UserTR(props) {
    const list = props.list

    // console.log('list',list)
    
    const deleteItem = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it'
        }).then((result) => {
            if (result.isConfirmed) {
                // Perform all deletions and wait for them to complete before deleting the user
                Promise.all([
                    deleteFromOrders(),
                    deleteFromItems(),
                    deleteFromItemToVerify(),
                    deleteFromOrderTrack()
                ])
                .then(() => {
                    // Deleting the user after all deletions are complete
                    const item = firebase.database().ref('users/').child(list.id);
                    item.remove().then(() => {
                        Swal.fire("User Deleted Successfully", "", "success");
                    }).catch((error) => {
                        Swal.fire("Error deleting user", error.message, "error");
                    });
                })
                .catch((error) => {
                    Swal.fire("Error deleting data", error.message, "error");
                });
            }
        });
    };
    
    const deleteFromOrders = () => {
        return new Promise((resolve, reject) => {
            firebase.database().ref("orders").once("value", (snap) => {
                var snapVal = snap.val();
                let promises = [];
                for (let id in snapVal) {
                    if (snapVal[id].userId === list.id || snapVal[id].sellerId === list.id) {
                        console.log(`Deleting order: ${id}`);
                        promises.push(firebase.database().ref("orders").child(id).remove());
                    }
                }
                // Ensure all promises are handled correctly
                Promise.all(promises).then(resolve).catch(reject);
            }).catch((error) => reject(error));
        });
    };
    
    const deleteFromItems = () => {
        return new Promise((resolve, reject) => {
            firebase.database().ref("items").once("value", (snap) => {
                var snapVal = snap.val();
                let promises = [];
                for (let id in snapVal) {
                    if (snapVal[id].sellerUID === list.id) {
                        console.log(`Deleting item: ${id}`);
                        promises.push(firebase.database().ref("items").child(id).remove());
                    }
                }
                // Ensure all promises are handled correctly
                Promise.all(promises).then(resolve).catch(reject);
            }).catch((error) => reject(error));
        });
    };
    
    const deleteFromItemToVerify = () => {
        return new Promise((resolve, reject) => {
            firebase.database().ref("item-to-verify").once("value", (snap) => {
                var snapVal = snap.val();
                let promises = [];
                for (let id in snapVal) {
                    if (snapVal[id].sellerUID === list.id) {
                        console.log(`Deleting item-to-verify: ${id}`);
                        promises.push(firebase.database().ref("item-to-verify").child(id).remove());
                    }
                }
                // Ensure all promises are handled correctly
                Promise.all(promises).then(resolve).catch(reject);
            }).catch((error) => reject(error));
        });
    };
    
    const deleteFromOrderTrack = () => {
        return new Promise((resolve, reject) => {
            firebase.database().ref("order-track").once("value", (snap) => {
                var snapVal = snap.val();
                let promises = [];
                for (let id in snapVal) {
                    if (snapVal[id].buyerId === list.id || snapVal[id].sellerId === list.id) {
                        console.log(`Deleting order-track: ${id}`);
                        promises.push(firebase.database().ref("order-track").child(id).remove());
                    }
                }
                // Ensure all promises are handled correctly
                Promise.all(promises).then(resolve).catch(reject);
            }).catch((error) => reject(error));
        });
    };
    
    
    
    const showDetail = () => {
        delete list.farmerData
        delete list.product_for_sell
        delete list.item_rejected
        delete list.cart
        delete list.orders
        delete list.corporateData




        const theDetial = () => {
            var detail = ""
            Object.keys(list).map((col) => { detail = detail + `${col}: ${list[col]} <br>` })
            return detail
        }

        Swal.fire("The detail", `<div className="text-left">${theDetial()}</div>`, "info")
        console.log(list)

    }
    var timestamp = list.timeStamp
    var rawTime = String(new Date(timestamp))
    var timestamp = ""
    if (rawTime === "Invalid Date") {
        timestamp = ""
    }
    else {
        timestamp = rawTime.replace("GMT+0530 (India Standard Time)", "")
    }
    return (
        <TableRow
            key={list.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
        >
            <TableCell align="left">{props.index + 1}</TableCell>
            <TableCell align="left">{list.name}</TableCell>
            <TableCell align="left">{list.userType}</TableCell>
            <TableCell align="left">{list.phone}</TableCell>
            <TableCell align="left">{list.email}</TableCell>
            <TableCell align="left">{list.state}</TableCell>
            <TableCell align="left">{list.district}</TableCell>
            <TableCell align="left">{timestamp}</TableCell>
            <TableCell className="text-center">
                <i onClick={deleteItem} style={{ cursor: 'pointer', margin: '0 5px' }} className="fa fa-trash text-danger"></i>
            </TableCell>
            <TableCell className="text-center">
                <i onClick={showDetail} style={{ cursor: 'pointer', margin: '0 5px' }} className="fa fa-info-circle text-primary" aria-hidden="true"></i>
            </TableCell>
        </TableRow>
    )
}

export default UserTR
